export const SubscriptionTypes = ["Trial", "Premium"];

export const SubscriptionTypeRecords = SubscriptionTypes.map(
  (subscriptionType) => ({
    value: subscriptionType,
    label: subscriptionType,
  })
);
